import { Fade, Modal } from '@mui/material'
import PropTypes from 'prop-types'
import React, { useState } from 'react'

const ImageView = (props) => {
  const [open, setOpen] = useState(false)

  const handleClose = () => {
    setOpen(false)
  }

  const handleImage = () => {
    setOpen(true)
  }
  return (
    <>
      <img
        height={props.height}
        width={props.width}
        style={props.style}
        src={props.src}
        alt={props.alt}
        className={props.className}
        onClick={() => handleImage()}
      />

      <Modal
        open={open}
        onClose={handleClose}
        closeAfterTransition
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          '&:hover': { backgroundcolor: 'red' },
        }}
      >
        <Fade in={open} timeout={500}>
          <img
            src={props.src}
            alt={props.alt}
            style={{ outline: 'none', maxHeight: '80%', maxWidth: '80%', backgroundcolor: 'red' }}
          />
        </Fade>
      </Modal>
    </>
  )
}

ImageView.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
  alt: PropTypes.string,
  src: PropTypes.string,
  style: PropTypes.object,
  className: PropTypes.string,
}

export default ImageView
